module.exports = __webpack_public_path__ + "img/hair_front_female_updo.135b76d0.png";